import React from 'react'
import { Box, Button, FormHelperText, FormLabel, Grid, MenuItem, Select, TextField } from '@mui/material'


const RoleElevationRequestForm = ({roleList,userDetails,handleFormData,changeHandler,userData}) => {

  return (
    <Box sx={{ flexGrow: 1 }}>
        <Grid container direction="row">
            <Grid xs={12} sm={10} md={6}>
                <FormLabel id="file-select-label">Email Address</FormLabel>
                <TextField
                    margin="dense"
                    disabled
                    id="email"
                    fullWidth
                    name="email_address"
                    value={userDetails?.email} 
                    sx={{backgroundColor:'#F9F9F9'}} 
                />
            </Grid>
        </Grid>
        <Grid container direction="row">
            <Grid xs={12} sm={10} md={6}>
                <FormLabel id="file-select-label">Current Role</FormLabel> 
                <TextField
                    margin="dense"
                    disabled
                    id="current_role"
                    fullWidth
                    name="current_role"
                    value={userDetails?.rolename} 
                    sx={{backgroundColor:'#F9F9F9'}} 
                />
            </Grid> 
        </Grid>
        <Grid container direction="row">
            <Grid xs={12} sm={10} md={6}>
                <FormLabel id="demo-simple-select-standard-label">Select New Role</FormLabel>
                <Select
                    margin="dense"
                    fullWidth
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    sx={{ "&:focus": {
                            backgroundColor: "#ffffff"
                        } 
                    }}
                    //label="Select Role" 
                    value={userData.role_type}
                    onChange={changeHandler}
                    name="role_type"
                    error={userData.role_type === "" || userData.role_type === "undefined"}
                >
                <MenuItem value="">Select Role</MenuItem>
                { roleList?.map((role) => (
                    <MenuItem value={role.id}>{role.name}</MenuItem>
                ))}
                </Select>
                <FormHelperText sx={{color:"#d32f2f"}} >{userData.role_type === "" || userData.role_type === "undefined" ? "Required Field!" : ""}</FormHelperText>
            </Grid>
        </Grid>   
        {userData.role_type === 4 &&
            <Grid container direction="row">
                <Grid xs={12} sm={10} md={6}>
                    <FormLabel id="demo-simple-select-standard-label">Location</FormLabel>
                    <Select
                        margin="dense"
                        fullWidth
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        sx={{ "&:focus": {
                                backgroundColor: "#ffffff"
                            } 
                        }}
                        //label="Select Role" 
                        value={userData.location}
                        onChange={changeHandler}
                        name="location"
                        error={userData.location === "" || userData.location === "undefined"}
                    >
                        <MenuItem value="">Select Location</MenuItem>
                        <MenuItem value="NA">North America</MenuItem>
                        <MenuItem value="EMEA">Europe and Africa</MenuItem>
                        {/* <MenuItem value="APAC">Asia Pacific</MenuItem>
                        <MenuItem value="LATAM">Latin America</MenuItem> */}
                    </Select>
                    <FormHelperText sx={{color:"#d32f2f"}} >{userData.location === "" || userData.location === "undefined" ? "Required Field!" : ""}</FormHelperText>
                </Grid>
            </Grid> 
        }
        <Grid container direction="row">
            <Grid xs={12} sm={10} md={6}>
                <FormLabel id="file-select-label">Message</FormLabel> 
                <TextField 
                    margin="dense"
                    id="message" 
                    name="message"
                    multiline
                    rows={6}
                    fullWidth
                    sx={{paddingBottom:2}}
                    value={userData.message}
                    onChange={changeHandler}
                />
            </Grid> 
        </Grid>
        <Grid item xs={12}> 
            <Button  
                sx={{mr:1}}
                variant="contained"
                size="medium"
                color="primary" 
                onClick={handleFormData}
            >Submit</Button>
        </Grid>
    </Box>
  )
}

export default RoleElevationRequestForm